import axiosInstance from "./axiosInstance";
import { API_ENDPOINTS } from "./endpoints";

export const searchByUsers = async (page: number, size: number, sort: string) => {
  try {
    const response = await axiosInstance.get(`${API_ENDPOINTS.file}/stats/user?page=${page}&size=${size}&sort=${sort}`);
    return response.data;
  } catch (error: any) {
    console.log(error, "유저별 파일 검색 실패!");
  }
};

export const searchByMonth = async (page: number, size: number, sort: string) => {
  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.file}/stats/month?page=${page}&size=${size}&sort=${sort}`
    );
    return response.data;
  } catch (error: any) {
    console.log(error, "월별 파일 검색 실패!");
  }
};

export const searchByDate = async (page: number, size: number, sort: string) => {
  try {
    const response = await axiosInstance.get(`${API_ENDPOINTS.file}/stats/date?page=${page}&size=${size}&sort=${sort}`);
    return response.data;
  } catch (error: any) {
    console.log(error, "일별 파일 검색 실패!");
  }
};

export const searchByCourse = async (page: number, size: number, sort: string) => {
  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.file}/stats/course?page=${page}&size=${size}&sort=${sort}`
    );
    return response.data;
  } catch (error: any) {
    console.log(error, "코스별 파일 검색 실패!");
  }
};

// 삭제된 파일 통계 API
export const searchDeletedByUsers = async (page: number, size: number, sort: string) => {
  try {
    const response = await axiosInstance.get(`${API_ENDPOINTS.file}/deleted/stats/user?page=${page}&size=${size}&sort=${sort}`);
    return response.data;
  } catch (error: any) {
    console.log(error, "삭제된 파일 유저별 검색 실패!");
  }
};

export const searchDeletedByMonth = async (page: number, size: number, sort: string) => {
  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.file}/deleted/stats/month?page=${page}&size=${size}&sort=${sort}`
    );
    return response.data;
  } catch (error: any) {
    console.log(error, "삭제된 파일 월별 검색 실패!");
  }
};

export const searchDeletedByDate = async (page: number, size: number, sort: string) => {
  try {
    const response = await axiosInstance.get(`${API_ENDPOINTS.file}/deleted/stats/date?page=${page}&size=${size}&sort=${sort}`);
    return response.data;
  } catch (error: any) {
    console.log(error, "삭제된 파일 일별 검색 실패!");
  }
};

export const searchDeletedByCourse = async (page: number, size: number, sort: string) => {
  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.file}/deleted/stats/course?page=${page}&size=${size}&sort=${sort}`
    );
    return response.data;
  } catch (error: any) {
    console.log(error, "삭제된 파일 코스별 검색 실패!");
  }
};

export const searchDetail = async (
  creatorId: string,
  creatorNickname: string,
  createAtFrom: number,
  createAtTo: number,
  teamId: string,
  teamName: string,
  page: number,
  size: number,
  sort: string
) => {
  try {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.file}/search?creatorId=${creatorId}&creatorNickname=${creatorNickname}&createAtFrom=${createAtFrom}&createAtTo=${createAtTo}&teamId=${teamId}&teamName=${teamName}&page=${page}&size=${size}&sort=${sort}`
    );
    return response.data;
  } catch (error: any) {
    console.log(error, "파일 상세 검색 실패!");
  }
};

export const deleteByTeam = async (ids: String[]) => {
  try {
    const response = await axiosInstance.delete(`${API_ENDPOINTS.file}`, {
      data: { type: "team", ids, dateRanges: [] },
    });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "팀 기준 삭제 실패!");
  }
};

export const deleteByUser = async (ids: String[]) => {
  try {
    const response = await axiosInstance.delete(`${API_ENDPOINTS.file}`, {
      data: { type: "user", ids, dateRanges: [] },
    });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "사용자자 기준 삭제 실패!");
  }
};

export const deleteByFile = async (ids: String[]) => {
  try {
    const response = await axiosInstance.delete(`${API_ENDPOINTS.file}`, {
      data: { type: "file", ids, dateRanges: [] },
    });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "파일일 기준 삭제 실패!");
  }
};

export const deleteByDate = async (dateRanges: { startTime: number; endTime: number }[]) => {
  try {
    const response = await axiosInstance.delete(`${API_ENDPOINTS.file}`, {
      data: { type: "date", ids: [], dateRanges },
    });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "시간 기준 삭제 실패!");
  }
};

// 파일 복원 API
export const restoreByTeam = async (ids: String[]) => {
  try {
    const response = await axiosInstance.post(`${API_ENDPOINTS.file}/restore`, {
      type: "team",
      ids,
      dateRanges: [],
    });
    return response.data;
  } catch (error: any) {
    console.log(error, "팀 기준 복원 실패!");
  }
};

export const restoreByUser = async (ids: String[]) => {
  try {
    const response = await axiosInstance.post(`${API_ENDPOINTS.file}/restore`, {
      type: "user",
      ids,
      dateRanges: [],
    });
    return response.data;
  } catch (error: any) {
    console.log(error, "사용자 기준 복원 실패!");
  }
};

export const restoreByDate = async (dateRanges: { startTime: number; endTime: number }[]) => {
  try {
    const response = await axiosInstance.post(`${API_ENDPOINTS.file}/restore`, {
      type: "date",
      ids: [],
      dateRanges,
    });
    return response.data;
  } catch (error: any) {
    console.log(error, "시간 기준 복원 실패!");
  }
};
